import React from "react";
import { Reveal } from "@/components/ui-blocks/Reveal";

const PARTNERS = ["TATA", "INFOSYS", "WIPRO", "HDFC", "AXIS", "MAHINDRA", "BIRLA", "RELIANCE"];

export const PartnersStrip = () => (
  <section className="bg-background border-y border-[hsl(var(--border))]">
    <div className="container-wide py-8">
      <Reveal>
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-12 items-center">
          <div className="lg:col-span-3 text-sm text-[hsl(var(--muted-ink))]"><span className="font-semibold text-[hsl(var(--navy))]">Featured with</span> a growing network of corporate CSR and media partners.</div>
          <div data-testid="partners-strip" className="lg:col-span-9 grid grid-cols-4 md:grid-cols-8 gap-4 items-center">
            {PARTNERS.map((p) => (
              <div key={p} className="h-10 rounded-md border border-[hsl(var(--border))] grid place-items-center text-[11px] font-semibold text-[hsl(var(--navy))] tracking-widest bg-[hsl(var(--surface-tint))]">{p}</div>
            ))}
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
